module.exports = __webpack_public_path__ + "static/media/play_store_button.4c92a1bf.jpg";